import { Home, LogOut, ShieldAlert, Wrench } from 'lucide-react';
import './MaintenancePage.css';

const MaintenancePage = ({ onLogout }) => {
  return (
    <div className="maintenance-page">
      <main className="maintenance-shell" aria-labelledby="maintenance-title">
       

        <section className="maintenance-card">
          <div className="maintenance-status">
            <div className="maintenance-icon-wrap" aria-hidden="true">
              <Wrench size={42} strokeWidth={2.2} />
            </div>
            <span>Maintenance administrative</span>
          </div>

          <div className="maintenance-content">
            <span className="maintenance-kicker">
              <ShieldAlert size={16} />
              Accès administrateurs et modérateurs
            </span>

            <h1 id="maintenance-title">Backoffice temporairement indisponible</h1>

            <p>
              Le Backoffice est actuellement en maintenance.
              L'accès est temporairement suspendu pour les administrateurs et modérateurs.
              Merci de réessayer ultérieurement.
            </p>

            <div className="maintenance-signature">- L'Équipe IT Sastra Energy</div>
          </div>
        </section>

        <div className="maintenance-actions">
          <button
            type="button"
            onClick={() => window.location.href = '/'}
            className="maintenance-button secondary"
          >
            <Home size={18} />
            Accueil Public
          </button>

          <button
            type="button"
            onClick={onLogout}
            className="maintenance-button primary"
          >
            <LogOut size={18} />
            Déconnexion
          </button>
        </div>
      </main>
    </div>
  );
};

export default MaintenancePage;
